import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAllowOrder, selectAllowPrepaidCard } from '@us/web/shop/data-access';

export const checkAllowPrepaidCardGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const store = inject(Store);
    const allowPrepaidCard = store.selectSignal(selectAllowPrepaidCard);
    const allowOrder = store.selectSignal(selectAllowOrder);

    if (!allowPrepaidCard()) {
        if (!allowOrder()) {
            await router.navigateByUrl('/unavailable');
        } else {
            await router.navigateByUrl('/');
        }
        return false;
    }
    return true;
};
